import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter, HostListener, ViewContainerRef } from '@angular/core';
import { ModalDialogService, SimpleModalComponent } from '@preeco-privacy/ngx-modal-dialog';
import { ImageOptions } from 'src/app/core/image-compression/image-compression-logic.service';
import { environment } from 'src/environments/environment';
import { CompressionMediatorService } from 'src/app/core/image-compression/compression-mediator.service';
import { switchMap, map } from 'rxjs/operators';
import { fi } from 'date-fns/locale';

@Component({
	selector: 'app-file-picker',
	templateUrl: './file-picker.component.html',
	styleUrls: ['./file-picker.component.scss']
})
export class FilePickerComponent implements OnInit {

	public imageOptions: ImageOptions = {
		width: environment.imagesCompression.chat.width,
		height: environment.imagesCompression.chat.height,
		quality: environment.imagesCompression.chat.quality
	};

	@Input() formatFilter: string;

	@Input() isMultiSelect = false;

	@Input() disabled = false;

	@Input() fileSizeLimit?: number = null;

	@Output() filesSelected = new EventEmitter<File[]>();

	@ViewChild('picker', { static: false }) picker: ElementRef;

	@HostListener('click', ['$event']) onClick(event: MouseEvent) {
		if (!this.disabled) {
			this.openPicker(event);
		}
	}

	constructor(
		private modalDialogService: ModalDialogService,
		private viewContainer: ViewContainerRef,
		private imageCompressMediator: CompressionMediatorService
	) { }

	get fileInput(): HTMLInputElement { return this.picker?.nativeElement; }

	ngOnInit() {
	}

	openPicker(event: MouseEvent) {
		if (this.fileInput) {
			this.fileInput.click();
			this.cancelPropagation(event);
		}
	}

	cancelPropagation(event: MouseEvent) {
		if (event) {
			event.stopPropagation();
		}
	}

	handleFiles() {
		if (this.fileInput && this.fileInput.files && this.fileInput.files.length > 0) {
			const files: File[] = [];


			const file = this.imageCompressMediator.compressImage(this.fileInput.files.item(0), this.imageOptions);
			file.subscribe(res => {
				files.push(res);
				if (this.fileSizeLimit === null || this.fileSizeLimit === 0 || this.isValidSize(files)) {
					this.filesSelected.emit(files);
				}
			});
		}
	}

	isValidSize(files: File[]): boolean {
		const tooBigFiles = files.filter(x => x.size > this.fileSizeLimit);

		if (tooBigFiles.length > 0) {
			const fileNames = tooBigFiles.map(x => x.name).join(', ');
			const maxSize = this.fileSizeLimit / 1024 / 1024;
			const fileInfoText = fileNames.length > 1
				? `Pliki ${fileNames} są za duże`
				: `Plik ${fileNames} jest za duży`;
			const message = `${fileInfoText}. Maksymalny rozmiar to ${maxSize.toPrecision(2)} Mb.`;

			this.modalDialogService.openDialog(this.viewContainer, {
				title: 'Błąd',
				childComponent: SimpleModalComponent,
				settings: {
					closeButtonClass: 'close'
				},
				data: {
					text: message
				},
				actionButtons: [
					{
						text: 'Wybierz ponownie',
						onAction: () => new Promise((resolve: any) => {
							setTimeout(() => {
								this.openPicker(null);
								resolve();
							}, 20);
						})
					},
					{
						text: 'Anuluj',
						onAction: () => new Promise((resolve: any) => {
							setTimeout(() => {
								resolve();
							}, 20);
						})
					}
				]
			});

			return false;
		} else {
			return true;
		}
	}
}
